import { useState } from "react";
import { ThemeProvider } from "@material-ui/core";
import { bonlivaPipelineTheme } from "@bonliva-crm/ui";
import { UserSelectorModalUserFragment } from "@bonliva-crm/graphql";
import { GlobalUserSelectorProvider } from "./global-user-selector";
import { UserSelectorModal, UserSelectorModalProps } from "./user-selector-modal";

type Props = {
  children: React.ReactNode;
};

export function WithGlobalUserSelector(props: Props) {
  const [modal, setModal] = useState<UserSelectorModalProps | null>({
    open: false,
    multi: false,
    onClose: () => {},
    onSelected: () => {}
  });

  return (
    <GlobalUserSelectorProvider
      value={{
        select: (options: { multi: boolean }) => {
          return new Promise<UserSelectorModalUserFragment[]>((resolve) => {
            setModal({
              open: true,
              multi: options.multi,
              onClose: () => {
                setModal(null);
                resolve([]);
              },
              onSelected: (selected) => {
                setModal(null);
                resolve(selected);
              }
            });
          });
        }
      }}
    >
      {props.children}
      <ThemeProvider theme={bonlivaPipelineTheme}>
        <UserSelectorModal {...modal} />
      </ThemeProvider>
    </GlobalUserSelectorProvider>
  );
}
